import useProductMainImage from '~/hooks/components/use-product-main-image';
import { BundleProduct } from './BundleLineItem';
import LineItemGeneric from './LineItemGeneric';

type Props = {
  product: BundleProduct;
  kit: boolean;
};

const IndividualProduct = ({ product, kit }: Props) => {
  const { image } = useProductMainImage({ slug: product.variant.slug ?? '', sku: product.sku });

  const {
    variant: { optionValues },
  } = product;
  // @ts-ignore, they have a typo in their type declaration
  const color = optionValues.find((option) => /color/i.test(option.optionTypeName))?.presentation;

  // @ts-ignore, they have a typo in their type declaration
  const size = optionValues.find((option) => /size/i.test(option.optionTypeName))?.presentation;

  return (
    <LineItemGeneric
      image={image}
      kit={kit}
      title={product.variant.name}
      size={size ?? ''}
      color={color ?? ''}
      quantity={product.quantity}
      id={product.id}
      optionalShippingNote={product.optionalShippingNote ?? ''}
    />
  );
};

export default IndividualProduct;
